"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const encryption_format_1 = require("./encryption/encryption-format");
const hash_format_1 = require("./hash/hash-format");
const identity_format_1 = require("./identity/identity-format");
const plain_format_1 = require("./plain/plain-format");
/** Serializes and deserializes any multi-format supported */
exports.default = {
    deserialize,
    encryptionFormats: encryption_format_1.default,
    hashFormat: hash_format_1.default,
    identityFormat: identity_format_1.default,
    plainFormat: plain_format_1.default,
    serialize,
};
/** List of the groups of formats available */
const availableFormats = [
    encryption_format_1.default,
    identity_format_1.default,
    hash_format_1.default,
    plain_format_1.default,
];
/**
 * Deserializes any supported serialized string
 *
 * @param formatted the string to deserialize
 * @returns the deserialized object or throw
 */
function deserialize(formatted) {
    const matchingFormat = availableFormats.find((format) => format.isDeserializableString(formatted));
    if (matchingFormat) {
        return matchingFormat.deserialize(formatted);
    }
    throw new Error('No format found to deserialize this string');
}
/**
 * Serializes any supported serializable object
 *
 * @param data the object to serialize
 * @returns the serialized string or throw.
 */
function serialize(data) {
    const matchingFormat = availableFormats.find((format) => format.isSerializableObject(data));
    if (matchingFormat) {
        return matchingFormat.serialize(data);
    }
    throw new Error('No format found to serialize this object');
}
